module.exports = __webpack_public_path__ + "static/media/profile1.f1e88195.jpg";